import { connectedStore } from '../../store';
import selectors from '../selectors';

const getVariables = () => {
  const store = connectedStore.get();
  const state = store.getState();

  return selectors.getVariables(state);
};

export default getVariables;
